import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Meta from 'vue-meta'
import store from '@/store'

const Program = () => import(/* webpackChunkName: "pages" */ '@/views/Program')
const Journal = () => import(/* webpackChunkName: "issues" */ '@/views/Journal')

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:locale?',
      component: {
        name: 'Locale',
        render (h) {
          return h('router-view')
        }
      },
      children: [
        {
          path: '',
          name: 'home',
          component: Home,
          alias: '/'
        },
        {
          path: 'program',
          name: 'program',
          component: Program
        },
        {
          path: 'learning-and-experience',
          name: 'learning',
          component: Program
        },
        {
          path: '(program|learning-and-experience)/:type?/:slug',
          name: 'exhibition',
          component: () => import(/* webpackChunkName: "pages" */ '@/views/Exhibition')
        },
        {
          path: 'books',
          name: 'books',
          component: () => import(/* webpackChunkName: "pages" */ '@/views/Books'),
          beforeEnter (to, from, next) {
            store.dispatch('getBooks').then(next)
          }
        },
        {
          path: 'books/:slug',
          name: 'book',
          component: () => import(/* webpackChunkName: "pages" */ '@/views/Book'),
          beforeEnter (to, from, next) {
            store.dispatch('getBook', to.params.slug).then(next)
          },
          meta: {
            backTo: 'books'
          }
        },
        {
          path: 'news',
          name: 'news',
          component: () => import(/* webpackChunkName: "pages" */ '@/views/News'),
          beforeEnter (to, from, next) {
            store.dispatch('getNews').then(next)
          },
          meta: {
            backTo: 'news'
          }
        },
        {
          path: 'news/:slug',
          name: 'news-item',
          component: () => import(/* webpackChunkName: "pages" */ '@/views/NewsSingle'),
          beforeEnter (to, from, next) {
            store.dispatch('getNewsItem', to.params.slug).then(next)
          },
          meta: {
            backTo: 'news'
          }
        },
        {
          path: 'journal',
          name: 'journal',
          component: Journal
        },

        {
          path: 'journal/:issue',
          name: 'issue',
          component: Journal
        },

        {
          path: 'journal/:issue/:slug',
          name: 'article',
          component: () => import(/* webpackChunkName: "issues" */ '@/views/Article')
        },

        {
          path: '(people|institutions)/:slug',
          name: 'entity',
          component: () => import(/* webpackChunkName: "entities" */ '@/views/Entity')
        },

        {
          path: 'visit',
          name: 'visit',
          component: () => import(/* webpackChunkName: "pages" */ '@/views/Visit'),
          meta: {
            backTo: ''
          }
        },
        {
          path: 'about/:slug?',
          name: 'about',
          component: () => import(/* webpackChunkName: "pages" */ '@/views/About')
        },
        {
          path: 'support-us',
          name: 'support-us',
          component: () => import(/* webpackChunkName: "pages" */ '@/views/ContentPage'),
          meta: {
            backTo: ''
          }
        },
        {
          path: 'berlin',
          name: 'berlin',
          component: () => import(/* webpackChunkName: "berlin" */ '@/views/ContentPage'),
          meta: {
            contentSlug: 'times-art-center-berlin'
          }
        },
        {
          path: 'test',
          name: 'test',
          component: () => import(/* webpackChunkName: "test" */ '@/views/Test')
        },
        {
          path: 'login',
          name: 'login',
          component: () => import(/* webpackChunkName: "login" */ '@/views/Login')
        },
        {
          path: '*',
          name: 'notfound',
          component: () => import(/* webpackChunkName: "notfound" */ '@/views/NotFound')
        }
      ]
    },
    {
      path: '*',
      name: 'alsonotfound',
      component: () => import(/* webpackChunkName: "notfound" */ '@/views/NotFound')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

const locales = ['en', 'cn']

router.beforeEach((to, from, next) => {
  store.commit('FROM_PAGE', from.name)
  store.commit('FROM_LOCALE', from.params.locale)

  const { fullPath, params } = to
  if (!locales.includes(params.locale)) {
    next('/cn' + (fullPath !== '/' ? fullPath : ''))
    return
  }
  next()
})

router.beforeEach((to, from, next) => {
  const preview = window.TIMES_PREVIEW
  if (preview && preview === true) {
    store.dispatch('session').then(next)
  } else {
    next()
  }
})

const withBg = ['journal', 'issue', 'article', 'about']

router.afterEach((to) => {
  if (!withBg.includes(to.name)) {
    store.commit('RESET_STYLE')
  }
})

export default router
